<!-- Header -->
<div class="flex grid-cols-2 flex-col gap-4 md:grid md:justify-between">
  <h2 class="text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17">
    Bank Details
  </h2>
</div>

<!-- Filter -->
<div class="flex gap-3">
  <app-filters
    [filters]="filterStructure"
  ></app-filters>
  <app-table-refresh class="mt-5" [tableKey]="'banks'"></app-table-refresh>
</div>

<!-- Table -->
<div class="mt-[0.94rem] overflow-x-auto sm:-mx-6 lg:-mx-8">
  <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
    <div
      class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      (click)="closeEdit()"
    >
      <table class="min-w-full leading-normal">
        <thead>
          <tr>
            <th class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600">
              S/N
            </th>
            <th class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600">
              Bank Name
            </th>
            <th class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600">
              ID
            </th>
            <th class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600">
              Providus Code
            </th>
            <th class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600">
              Paystack Code
            </th>
            <th class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600">
              Actions
            </th>
          </tr>
        </thead>

        <tbody>
          @for (bank of (bankList$ | async); track bank.bankCode; let i = $index) {
            <tr class="transition-colors hover:bg-gray-50">
              <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                {{ i + 1 }}
              </td>

              <!-- Bank Name -->
              <td 
                class="border-b border-gray-200 bg-white px-5 py-5 text-sm" 
                (click)="$event.stopPropagation(); !isEditing(bank.bankCode) && enableEdit(bank.bankCode)"
                [style.cursor]="!isEditing(bank.bankCode) ? 'url(\'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzM3NDE1MSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBkPSJNMjEuNzMxIDIuMjY5YTIuNjI1IDIuNjI1IDAgMCAwLTMuNzEyIDBsLTEuMTU3IDEuMTU3IDMuNzEyIDMuNzEyIDEuMTU3LTEuMTU3YTIuNjI1IDIuNjI1IDAgMCAwIDAtMy43MTJaTTE5LjUxMyA4LjE5OWwtMy43MTItMy43MTItMTIuMTUgMTIuMTVhNS4yNSA1LjI1IDAgMCAwLTEuMzIgMi4yMTRsLS44IDIuNjg1YS43NS43NSAwIDAgMCAuOTMzLjkzM2wyLjY4NS0uOGE1LjI1IDUuMjUgMCAwIDAgMi4yMTQtMS4zMkwxOS41MTMgOC4yWiIgLz48L3N2Zz4=\') 0 16, pointer' : 'default'"
              >
                <div *ngIf="isEditing(bank.bankCode)" [formGroup]="rowForms[bank.bankCode]">
                  <app-input
                    inputClass="input--padding"
                    placeholder="Enter Bank Name"
                    formControlName="bankName"
                  ></app-input>
                </div>
                <p *ngIf="!isEditing(bank.bankCode)" class="whitespace-no-wrap font-medium text-gray-900">
                  {{ bank.bankName }}
                </p>
              </td>

              <!-- ID -->
              <td class="cursor-not-allowed border-b border-gray-200 bg-white px-5 py-5 text-sm text-gray-500">
                {{ bank.bankCode }}
              </td>

              <!-- Providus Code -->
              <td 
                class="border-b border-gray-200 bg-white px-5 py-5 text-sm" 
                (click)="$event.stopPropagation(); !isEditing(bank.bankCode) && enableEdit(bank.bankCode)"
                [style.cursor]="!isEditing(bank.bankCode) ? 'url(\'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzM3NDE1MSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBkPSJNMjEuNzMxIDIuMjY5YTIuNjI1IDIuNjI1IDAgMCAwLTMuNzEyIDBsLTEuMTU3IDEuMTU3IDMuNzEyIDMuNzEyIDEuMTU3LTEuMTU3YTIuNjI1IDIuNjI1IDAgMCAwIDAtMy43MTJaTTE5LjUxMyA4LjE5OWwtMy43MTItMy43MTItMTIuMTUgMTIuMTVhNS4yNSA1LjI1IDAgMCAwLTEuMzIgMi4yMTRsLS44IDIuNjg1YS43NS43NSAwIDAgMCAuOTMzLjkzM2wyLjY4NS0uOGE1LjI1IDUuMjUgMCAwIDAgMi4yMTQtMS4zMkwxOS41MTMgOC4yWiIgLz48L3N2Zz4=\') 0 16, pointer' : 'default'"
              >
                <div *ngIf="isEditing(bank.bankCode)" [formGroup]="rowForms[bank.bankCode]">
                  <app-input
                    inputClass="input--padding"
                    placeholder="Enter Providus Code"
                    formControlName="providusCode"
                  ></app-input>
                </div>
                <span *ngIf="!isEditing(bank.bankCode)" class="text-gray-700">
                  {{ bank.providus_code ? (bank.providus_code | truncate:25) : '---' }}
                </span>
              </td>

              <!-- Paystack Code -->
              <td 
                class="border-b border-gray-200 bg-white px-5 py-5 text-sm" 
                (click)="$event.stopPropagation(); !isEditing(bank.bankCode) && enableEdit(bank.bankCode)"
                [style.cursor]="!isEditing(bank.bankCode) ? 'url(\'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzM3NDE1MSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBkPSJNMjEuNzMxIDIuMjY5YTIuNjI1IDIuNjI1IDAgMCAwLTMuNzEyIDBsLTEuMTU3IDEuMTU3IDMuNzEyIDMuNzEyIDEuMTU3LTEuMTU3YTIuNjI1IDIuNjI1IDAgMCAwIDAtMy43MTJaTTE5LjUxMyA4LjE5OWwtMy43MTItMy43MTItMTIuMTUgMTIuMTVhNS4yNSA1LjI1IDAgMCAwLTEuMzIgMi4yMTRsLS44IDIuNjg1YS43NS43NSAwIDAgMCAuOTMzLjkzM2wyLjY4NS0uOGE1LjI1IDUuMjUgMCAwIDAgMi4yMTQtMS4zMkwxOS41MTMgOC4yWiIgLz48L3N2Zz4=\') 0 16, pointer' : 'default'"
              >
                <div *ngIf="isEditing(bank.bankCode)" [formGroup]="rowForms[bank.bankCode]">
                  <app-input
                    inputClass="input--padding"
                    placeholder="Enter Paystack Code"
                    formControlName="paystackCode"
                  ></app-input>
                </div>
                <span *ngIf="!isEditing(bank.bankCode)" class="text-gray-700">
                  {{ bank.paystack_code ? (bank.paystack_code | truncate:25) : '---' }}
                </span>
              </td>

              <!-- Actions -->
              <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm" (click)="$event.stopPropagation()">
                <div *ngIf="isEditing(bank.bankCode)" class="flex gap-3">
                  <button 
                    class="rounded-full p-1.5 transition-colors hover:bg-green-200 disabled:opacity-50"
                    [disabled]="rowForms[bank.bankCode].pristine || rowForms[bank.bankCode].invalid || (isUpdatingBank$ | async)!"
                    (click)="saveRow(bank)"
                  >
                    <svg *ngIf="!(isUpdatingBank$ | async)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="text-mango-pineGreen"><polyline points="20 6 9 17 4 12"/></svg>
                    <span *ngIf="(isUpdatingBank$ | async)" class="h-4 w-4 animate-spin rounded-full border-2 border-mango-pineGreen border-t-transparent"></span>
                  </button>
                  <button 
                    class="rounded-full p-1.5 transition-colors hover:bg-red-200"
                    [disabled]="(isUpdatingBank$ | async)"
                    (click)="cancelEdit(bank.bankCode)"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="text-mango-red707"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                  </button>
                </div>
              </td>
            </tr>
          }

          <!-- New Bank Row -->
          <tr *ngIf="isAddingRow" class="bg-blue-50/30" (click)="$event.stopPropagation()">
            <td class="border-b border-gray-200 px-5 py-5 text-sm">
              *
            </td>
            <td class="border-b border-gray-200 px-5 py-5 text-sm" [formGroup]="addBankForm">
              <app-input
                inputClass="input--padding"
                placeholder="Enter Bank Name"
                formControlName="bank_name"
              ></app-input>
            </td>
            <td class="border-b border-gray-200 px-5 py-5 text-sm font-mono text-gray-500">
              {{ newBankId }}
            </td>
            <td class="border-b border-gray-200 px-5 py-5 text-sm" [formGroup]="addBankForm">
              <app-input
                inputClass="input--padding"
                placeholder="Enter Providus Code"
                formControlName="providusCode"
              ></app-input>
            </td>
            <td class="border-b border-gray-200 px-5 py-5 text-sm" [formGroup]="addBankForm">
              <app-input
                inputClass="input--padding"
                placeholder="Enter Paystack Code"
                formControlName="paystackCode"
              ></app-input>
            </td>
            <td class="border-b border-gray-200 px-5 py-5 text-sm">
              <div class="flex gap-3">
                <button 
                  class="rounded-full p-1.5 transition-colors hover:bg-green-200 disabled:opacity-50"
                  [disabled]="addBankForm.invalid || (isCreatingBank$ | async)!"
                  (click)="saveNewBank()"
                >
                  <svg *ngIf="!(isCreatingBank$ | async)" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="text-mango-pineGreen"><polyline points="20 6 9 17 4 12"/></svg>
                  <span *ngIf="(isCreatingBank$ | async)" class="h-5 w-5 animate-spin rounded-full border-2 border-mango-pineGreen border-t-transparent"></span>
                </button>
                <button 
                  class="rounded-full p-1.5 transition-colors hover:bg-red-200"
                  [disabled]="(isCreatingBank$ | async)"
                  (click)="cancelAdd()" 
                >
                   <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="text-mango-red707"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Add Bank Button -->
      <div class="flex border-t border-gray-200 bg-white p-4">
        <button 
          *ngIf="!isAddingRow"
          mango-button 
          variant="outline"
          class="!border-dashed !border-gray-300 !text-mango-floralWhite hover:!border-mango-primary hover:!text-mango-primary"
          (click)="startAdd(); $event.stopPropagation()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 inline-block"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          Add Bank
        </button>
      </div>

      <!-- Pagination -->
      <app-table-navigator
        [total]="(totalCount$ | async) || 0"
        (onNavigation)="navigate($event)"
      ></app-table-navigator>
    </div>
  </div>
</div>